import isPrimitive from './is-primitive';

export default (callback) => {
  if (isPrimitive(callback)) {
    return async () => callback;
  }

  if (callback.constructor.name === 'AsyncFunction') {
    return callback;
  }

  return async (...params) => callback(...params);
};
